
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue?macro=true";
import { default as referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue?macro=true";
import { default as termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue?macro=true";
import { default as account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue?macro=true";
import { default as pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue?macro=true";
import { default as my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue?macro=true";
import { default as ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue?macro=true";
import { default as privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue?macro=true";
import { default as talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue?macro=true";
import { default as ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue?macro=true";
import { default as avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue?macro=true";
import { default as history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue?macro=true";
import { default as talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue?macro=true";
import { default as ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue?macro=true";
import { default as talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue?macro=true";
import { default as ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue?macro=true";
import { default as ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue?macro=true";
import { default as ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue?macro=true";
import { default as component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLEMeta } from "/data/root-data/TG/lip-sync/master/lip-sync/node_modules/.pnpm/nuxt@3.21.5_@parcel+watcher@2.5.6_@types+node@22.19.19_@vue+compiler-sfc@3.5.34_cac@6.7_4adf07b75c9a1864ecbe33d0178da214/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLE } from "/data/root-data/TG/lip-sync/master/lip-sync/node_modules/.pnpm/nuxt@3.21.5_@parcel+watcher@2.5.6_@types+node@22.19.19_@vue+compiler-sfc@3.5.34_cac@6.7_4adf07b75c9a1864ecbe33d0178da214/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___en",
    path: "/",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___id",
    path: "/id",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___cn",
    path: "/cn",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___kr",
    path: "/kr",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    meta: indexq71mWYqdlqZmopi37Vl_45HudNcSY5A9by16_bGtbcW5sMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/index.vue")
  },
  {
    name: "refer___en",
    path: "/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___ru",
    path: "/ru/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___ja",
    path: "/ja/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___id",
    path: "/id/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___ar",
    path: "/ar/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___cn",
    path: "/cn/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___de",
    path: "/de/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___es",
    path: "/es/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___fr",
    path: "/fr/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___it",
    path: "/it/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___kr",
    path: "/kr/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___nl",
    path: "/nl/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___pt",
    path: "/pt/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___tr",
    path: "/tr/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "refer___zh",
    path: "/zh/refer",
    meta: { ...(referOJZPVCTJ8Xb4Fa1XOvZLE2Ib6axTbEPSkRdepD9ci84Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/refer.vue")
  },
  {
    name: "terms___en",
    path: "/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___ru",
    path: "/ru/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___ja",
    path: "/ja/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___id",
    path: "/id/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___ar",
    path: "/ar/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___cn",
    path: "/cn/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___de",
    path: "/de/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___es",
    path: "/es/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___fr",
    path: "/fr/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___it",
    path: "/it/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___kr",
    path: "/kr/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___nl",
    path: "/nl/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___pt",
    path: "/pt/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___tr",
    path: "/tr/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "terms___zh",
    path: "/zh/terms",
    meta: { ...(termsRTKxKHAEEKa5rvO_5etsBe7p_xERxwm2_45ZHlJYz4CRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/terms.vue")
  },
  {
    name: "account___en",
    path: "/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___ru",
    path: "/ru/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___ja",
    path: "/ja/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___id",
    path: "/id/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___ar",
    path: "/ar/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___cn",
    path: "/cn/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___de",
    path: "/de/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___es",
    path: "/es/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___fr",
    path: "/fr/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___it",
    path: "/it/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___kr",
    path: "/kr/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___nl",
    path: "/nl/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___pt",
    path: "/pt/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___tr",
    path: "/tr/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "account___zh",
    path: "/zh/account",
    meta: { ...(account2mg9jY1Z6_45poOL9CcMxQW1tkHRoTc1SydNljCQr_45GWgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/account.vue")
  },
  {
    name: "pricing___en",
    path: "/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___ru",
    path: "/ru/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___ja",
    path: "/ja/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___id",
    path: "/id/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___ar",
    path: "/ar/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___cn",
    path: "/cn/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___de",
    path: "/de/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___es",
    path: "/es/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___fr",
    path: "/fr/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___it",
    path: "/it/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___kr",
    path: "/kr/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___nl",
    path: "/nl/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___pt",
    path: "/pt/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___tr",
    path: "/tr/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "pricing___zh",
    path: "/zh/pricing",
    meta: pricingbfR_bZ2OHnUOZgayjeZmg5rjz2h6uXzERdWUBxDrZ5EMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/pricing.vue")
  },
  {
    name: "my-creations___en",
    path: "/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___ru",
    path: "/ru/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___ja",
    path: "/ja/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___id",
    path: "/id/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___ar",
    path: "/ar/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___cn",
    path: "/cn/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___de",
    path: "/de/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___es",
    path: "/es/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___fr",
    path: "/fr/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___it",
    path: "/it/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___kr",
    path: "/kr/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___nl",
    path: "/nl/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___pt",
    path: "/pt/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___tr",
    path: "/tr/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "my-creations___zh",
    path: "/zh/my-creations",
    meta: { ...(my_45creations_45kd_7rSduKUp245_45wHwnq_45hgjq0VU_45Zf0tFb0SvTuRAMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/my-creations.vue")
  },
  {
    name: "ai-news-anchor___en",
    path: "/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___ru",
    path: "/ru/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___ja",
    path: "/ja/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___id",
    path: "/id/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___ar",
    path: "/ar/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___cn",
    path: "/cn/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___de",
    path: "/de/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___es",
    path: "/es/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___fr",
    path: "/fr/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___it",
    path: "/it/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___kr",
    path: "/kr/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___nl",
    path: "/nl/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___pt",
    path: "/pt/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___tr",
    path: "/tr/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "ai-news-anchor___zh",
    path: "/zh/ai-news-anchor",
    meta: ai_45news_45anchorkiOOVwypoDdLGcFhB_Liox3q2M3Uh_45qawXWOaJ9YrrIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-news-anchor.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ru",
    path: "/ru/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ja",
    path: "/ja/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___id",
    path: "/id/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ar",
    path: "/ar/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___cn",
    path: "/cn/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___de",
    path: "/de/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___es",
    path: "/es/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___fr",
    path: "/fr/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___it",
    path: "/it/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___kr",
    path: "/kr/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___nl",
    path: "/nl/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___pt",
    path: "/pt/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___tr",
    path: "/tr/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___zh",
    path: "/zh/privacy-policy",
    meta: { ...(privacy_45policyXSpcM6iJsMNvcAxvlcB6tAsWktQXUftehnc22jfBB50Meta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/privacy-policy.vue")
  },
  {
    name: "talking-avatar___en",
    path: "/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___ru",
    path: "/ru/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___ja",
    path: "/ja/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___id",
    path: "/id/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___ar",
    path: "/ar/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___cn",
    path: "/cn/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___de",
    path: "/de/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___es",
    path: "/es/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___fr",
    path: "/fr/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___it",
    path: "/it/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___kr",
    path: "/kr/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___nl",
    path: "/nl/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___pt",
    path: "/pt/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___tr",
    path: "/tr/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "talking-avatar___zh",
    path: "/zh/talking-avatar",
    meta: talking_45avatar_45n95qXJsFMz4UvllwoWBxhzIDnogWnr058Dad1_45FXyUMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-avatar.vue")
  },
  {
    name: "ai-baby-podcast___en",
    path: "/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___ru",
    path: "/ru/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___ja",
    path: "/ja/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___id",
    path: "/id/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___ar",
    path: "/ar/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___cn",
    path: "/cn/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___de",
    path: "/de/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___es",
    path: "/es/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___fr",
    path: "/fr/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___it",
    path: "/it/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___kr",
    path: "/kr/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___nl",
    path: "/nl/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___pt",
    path: "/pt/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___tr",
    path: "/tr/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "ai-baby-podcast___zh",
    path: "/zh/ai-baby-podcast",
    meta: ai_45baby_45podcast0nW2NZ6Y9u3jzvV1CMcg5WNYwP_bdjHg_45gsnEjU1wQQMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-baby-podcast.vue")
  },
  {
    name: "avatar-dialogue___en",
    path: "/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___ru",
    path: "/ru/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___ja",
    path: "/ja/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___id",
    path: "/id/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___ar",
    path: "/ar/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___cn",
    path: "/cn/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___de",
    path: "/de/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___es",
    path: "/es/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___fr",
    path: "/fr/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___it",
    path: "/it/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___kr",
    path: "/kr/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___nl",
    path: "/nl/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___pt",
    path: "/pt/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___tr",
    path: "/tr/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "avatar-dialogue___zh",
    path: "/zh/avatar-dialogue",
    meta: avatar_45dialogue2MP9G4w7D5hGYvAYh5MVhGKBsunZ23fyQSDreglAs7QMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/avatar-dialogue.vue")
  },
  {
    name: "history-lipsync___en",
    path: "/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___ru",
    path: "/ru/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___ja",
    path: "/ja/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___id",
    path: "/id/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___ar",
    path: "/ar/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___cn",
    path: "/cn/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___de",
    path: "/de/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___es",
    path: "/es/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___fr",
    path: "/fr/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___it",
    path: "/it/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___kr",
    path: "/kr/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___nl",
    path: "/nl/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___pt",
    path: "/pt/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___tr",
    path: "/tr/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "history-lipsync___zh",
    path: "/zh/history-lipsync",
    meta: { ...(history_45lipsync3ExyrBeUh6zCH9GyU5BCmTcbDhN_45f_xD7VAgC39zCxgMeta || {}), ...{"sitemap":false} },
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/history-lipsync.vue")
  },
  {
    name: "talking-animals___en",
    path: "/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___ru",
    path: "/ru/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___ja",
    path: "/ja/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___id",
    path: "/id/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___ar",
    path: "/ar/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___cn",
    path: "/cn/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___de",
    path: "/de/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___es",
    path: "/es/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___fr",
    path: "/fr/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___it",
    path: "/it/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___kr",
    path: "/kr/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___nl",
    path: "/nl/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___pt",
    path: "/pt/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___tr",
    path: "/tr/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "talking-animals___zh",
    path: "/zh/talking-animals",
    meta: talking_45animalsOef9AwboIL2Y_45P5Q6Sr6OmBosI5y5nuEYy44F_B8wUsMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-animals.vue")
  },
  {
    name: "ai-singing-photo___en",
    path: "/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___ru",
    path: "/ru/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___ja",
    path: "/ja/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___id",
    path: "/id/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___ar",
    path: "/ar/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___cn",
    path: "/cn/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___de",
    path: "/de/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___es",
    path: "/es/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___fr",
    path: "/fr/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___it",
    path: "/it/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___kr",
    path: "/kr/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___nl",
    path: "/nl/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___pt",
    path: "/pt/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___tr",
    path: "/tr/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "ai-singing-photo___zh",
    path: "/zh/ai-singing-photo",
    meta: ai_45singing_45photordn8ugc69fF_V0HXjfOV2WW6KbYcIwE09QRhCYEyPR0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-singing-photo.vue")
  },
  {
    name: "talking-photo-ai___en",
    path: "/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___ru",
    path: "/ru/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___ja",
    path: "/ja/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___id",
    path: "/id/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___ar",
    path: "/ar/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___cn",
    path: "/cn/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___de",
    path: "/de/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___es",
    path: "/es/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___fr",
    path: "/fr/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___it",
    path: "/it/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___kr",
    path: "/kr/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___nl",
    path: "/nl/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___pt",
    path: "/pt/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___tr",
    path: "/tr/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "talking-photo-ai___zh",
    path: "/zh/talking-photo-ai",
    meta: talking_45photo_45aiTn8dVHeUp9562xVWwm7BY8IcmU7_eicSOny3WIQ4ulMMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/talking-photo-ai.vue")
  },
  {
    name: "ai-avatar-generator___en",
    path: "/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___ru",
    path: "/ru/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___ja",
    path: "/ja/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___id",
    path: "/id/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___ar",
    path: "/ar/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___cn",
    path: "/cn/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___de",
    path: "/de/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___es",
    path: "/es/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___fr",
    path: "/fr/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___it",
    path: "/it/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___kr",
    path: "/kr/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___nl",
    path: "/nl/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___pt",
    path: "/pt/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___tr",
    path: "/tr/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-avatar-generator___zh",
    path: "/zh/ai-avatar-generator",
    meta: ai_45avatar_45generator_45qZNCqTmJXIA9lquYZKPf6cz_45NZ63S6_xFhKlxAgqJYMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-avatar-generator.vue")
  },
  {
    name: "ai-influencer-generator___en",
    path: "/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___ru",
    path: "/ru/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___ja",
    path: "/ja/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___id",
    path: "/id/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___ar",
    path: "/ar/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___cn",
    path: "/cn/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___de",
    path: "/de/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___es",
    path: "/es/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___fr",
    path: "/fr/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___it",
    path: "/it/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___kr",
    path: "/kr/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___nl",
    path: "/nl/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___pt",
    path: "/pt/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___tr",
    path: "/tr/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-influencer-generator___zh",
    path: "/zh/ai-influencer-generator",
    meta: ai_45influencer_45generatoruX4k2qJ5RBBUi3qTqZq040hwnJwN9Fj0zFQKUPYs7B0Meta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-influencer-generator.vue")
  },
  {
    name: "ai-animate-face-lip-sync___en",
    path: "/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___ru",
    path: "/ru/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___ja",
    path: "/ja/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___id",
    path: "/id/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___ar",
    path: "/ar/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___cn",
    path: "/cn/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___de",
    path: "/de/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___es",
    path: "/es/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___fr",
    path: "/fr/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___it",
    path: "/it/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___kr",
    path: "/kr/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___nl",
    path: "/nl/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___pt",
    path: "/pt/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___tr",
    path: "/tr/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: "ai-animate-face-lip-sync___zh",
    path: "/zh/ai-animate-face-lip-sync",
    meta: ai_45animate_45face_45lip_45syncGB9_45_xo1q3ReJfK_LZSY7EcSotC2hHgCClL4McnlmkIMeta || {},
    component: () => import("/data/root-data/TG/lip-sync/master/lip-sync/src/pages/ai-animate-face-lip-sync.vue")
  },
  {
    name: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLEMeta?.name,
    path: "/sitemap.xml",
    component: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLE
  },
  {
    name: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLEMeta?.name,
    path: "/ru/sitemap.xml",
    component: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLE
  },
  {
    name: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLEMeta?.name,
    path: "/ja/sitemap.xml",
    component: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLE
  },
  {
    name: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLEMeta?.name,
    path: "/id/sitemap.xml",
    component: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLE
  },
  {
    name: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLEMeta?.name,
    path: "/ar/sitemap.xml",
    component: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLE
  },
  {
    name: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLEMeta?.name,
    path: "/cn/sitemap.xml",
    component: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLE
  },
  {
    name: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLEMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLE
  },
  {
    name: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLEMeta?.name,
    path: "/es/sitemap.xml",
    component: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLE
  },
  {
    name: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLEMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLE
  },
  {
    name: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLEMeta?.name,
    path: "/it/sitemap.xml",
    component: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLE
  },
  {
    name: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLEMeta?.name,
    path: "/kr/sitemap.xml",
    component: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLE
  },
  {
    name: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLEMeta?.name,
    path: "/nl/sitemap.xml",
    component: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLE
  },
  {
    name: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLEMeta?.name,
    path: "/pt/sitemap.xml",
    component: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLE
  },
  {
    name: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLEMeta?.name,
    path: "/tr/sitemap.xml",
    component: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLE
  },
  {
    name: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLEMeta?.name,
    path: "/zh/sitemap.xml",
    component: component_45stublrINRZw21CQd7ZRShbIlf3tDhLI__45HDwYFgVC12hJLE
  }
]